import { Box, Divider, Typography } from "@mui/material"
import { useStore } from "@priolo/jon"
import Paragraph from "components/controls/form/Paragraph"
import { TAGS } from "components/planner/types"
import RefCmp from "components/RefCmp"
import dayjs from "dayjs"
import { FunctionComponent, useMemo } from "react"
import { useTranslation } from "react-i18next"
import dialogSo from "stores/cycle/editDialog"
import { CYCLE_STATUS } from "stores/cycle/types"
import { getCropNames, getCycleStatus, getLabelCycleDayStatus } from "stores/cycle/utils/cycle"
import { EditCycle } from "stores/cycle/utils/edit"
import { SESSION_TYPE } from "stores/draft/type"
import guSo from "stores/growUnit"
import { getGrowUnitName } from "stores/growUnit/utils"
import { dateFormat } from "utils/humanize"
import CycleLayersShow from "../CycleLayersShow"
import CycleStatusBadge from "../../CycleStatusBadge"



const DetailTab: FunctionComponent = () => {

	// STORE
	const dialogSa = useStore(dialogSo)

	// HOOKs
	const { t } = useTranslation()

	// RENDER
	const guName = useMemo(() => getGrowUnitName(guSo.getByID(dialogSa?.cycle?.growUnitId)), [dialogSa?.cycle])

	if (!dialogSa.cycle) return null

	const isPreview = EditCycle.getExtra(dialogSa.cycle, TAGS.SESSION) == SESSION_TYPE.PREVIEW
	const cycleStatus = getCycleStatus(dialogSa.cycle)
	const harvestingDate = dialogSa.cycle.harvestingDate ? dayjs(dialogSa.cycle.harvestingDate).format("DD/MM/YYYY") : "--"
	const unitsYieldTot = dialogSa.cycle.cropLots?.reduce((acc, cl) => acc + (cl.unitsYield ?? 0), 0)
	const cycleYield = dialogSa.cycle.yield?.toFixed(1) ?? "--"
	const cyclePlannedYield = dialogSa.cycle.plannedYield?.toFixed(1) ?? "--"
	const flex = 25

	return <Box sx={{ display: "flex", flexDirection: "column" }}>

		<Paragraph flex={flex} title={t("pag.cycle.edit.ref")} >
			<RefCmp uuid={dialogSa.cycle.cycleUuid} />
		</Paragraph>

		<Paragraph flex={flex} title={t("pag.cycle.edit.gu")} >
			<Typography variant="subtitle2">{guName}</Typography>
		</Paragraph>

		<Paragraph flex={flex} title={t("pag.cycle.edit.status")} >
			<CycleStatusBadge cycleStatus={cycleStatus} label={isPreview ? "PREVIEW" : undefined} />
		</Paragraph>

		<Paragraph flex={flex} title={t("pag.cycle.edit.crop-name")} >
			<Typography>{getCropNames(dialogSa.cycle)}</Typography>
		</Paragraph>

		{!isPreview && cycleStatus == CYCLE_STATUS.HARVESTED && <>
			<Paragraph flex={flex} title={t("pag.cycle.edit.yield")} >
				<Typography>{cycleYield}</Typography>
			</Paragraph>
			<Paragraph flex={flex} title="UNITS YIELD" >
				<Typography>{unitsYieldTot ?? "--"}</Typography>
			</Paragraph>
		</>}

		{!isPreview && (
			<Paragraph flex={flex} title={t("pag.cycle.edit.seeding-date")} >
				<Typography>{dateFormat(dialogSa.cycle.seedingDate)}</Typography>
			</Paragraph>
		)}

		<Paragraph flex={flex} title={t("pag.cycle.edit.harvesting-date")} >
			<Typography>{harvestingDate}</Typography>
		</Paragraph>

		{!isPreview && (
			<Paragraph flex={flex} title={t("pag.cycle.edit.day")} >
				<Typography>{getLabelCycleDayStatus(dialogSa.cycle)}</Typography>
			</Paragraph>
		)}



		<Box sx={{ display: "flex", flexDirection: "column", margin: "12px 0px" }}>
			<Typography sx={theme => ({ color: theme.palette.text.disabled })} variant="caption">PHASES</Typography>
			<Divider />
		</Box>

		<CycleLayersShow />

	</Box>

}

export default DetailTab
